import { setIdentityProviderConfigurations } from "@redux/actions/identity-providers-actions";
import {
    IdentityProviderCategory,
    IdentityProviderClassification,
    IdentityProviderCompany,
    IdentityProviderLoa,
    IdentityProviderProtocol,
    IdentityProviderChangeRequestResponse
} from "@idw-types/data/identity-providers";
import { Dispatch } from "redux";
import { ChangeRequestStatusTypes } from "@enums/change-request-status-types";
import { getIdentityProviderConfigurationsRequest, updateIdentityProviderChangeRequestRequest } from "@requests/identity-provider";
import { formatIdentityProviderConfigurations } from "@formatters/identity-providers";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const updateIdentityProviderChangeRequestReduxRequest = (dispatch: Dispatch) => async (
    identityProviderId: string,
    body: { [key: string]: any },
    changeRequestStatus: ChangeRequestStatusTypes,
    categories: Array<IdentityProviderCategory>,
    classifications: Array<IdentityProviderClassification>,
    companies: Array<IdentityProviderCompany>,
    loas: Array<IdentityProviderLoa>,
    protocols: Array<IdentityProviderProtocol>
): Promise<IdentityProviderChangeRequestResponse> => {
    const { data, error } = await updateIdentityProviderChangeRequestRequest(identityProviderId, body, changeRequestStatus);
    if (data?.transferObject) {
        if (![ChangeRequestStatusTypes.REJECTED, ChangeRequestStatusTypes.APPROVED].includes(changeRequestStatus)) {
            const identityProviderConfigurationsResponse = await getIdentityProviderConfigurationsRequest();
            if (identityProviderConfigurationsResponse.data?.identityProviderConfigs) {
                const formattedIdentityProviderConfigurations = formatIdentityProviderConfigurations(
                    identityProviderConfigurationsResponse.data.identityProviderConfigs,
                    categories,
                    classifications,
                    companies,
                    loas,
                    protocols
                );
                dispatch(setIdentityProviderConfigurations(formattedIdentityProviderConfigurations));
                displaySuccessModal(
                    dispatch,
                    resources.requests.updateIdentityProviderChangeRequest.success.title,
                    resources.requests.updateIdentityProviderChangeRequest.success.message
                );
            }
        }
        return data.transferObject;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.updateIdentityProviderChangeRequest.error.title,
            resources.requests.updateIdentityProviderChangeRequest.error.message,
            null,
            null,
            body
        );
    }
    return null;
};